<template>
  <b-overlay :show="submitting" :rounded="true" opacity="0">
    <b-form class="responsive-form" @submit="onSubmit" @reset="onReset">
      <!-- name -->
      <b-form-group
          id="input-group-name"
          label="Nombre:"
          label-for="input-name"
          class="mb-2"
          label-cols-md="2"
          content-cols-md="9"
          label-cols-lg="2"
          content-cols-lg="8"
      >
        <b-form-input
            id="name"
            v-model="form.name"
            class="mt-1"
            type="text"
            placeholder="Entra tu nombre"
            required
        ></b-form-input>
      </b-form-group>

      <!-- lastname -->
      <b-form-group
          id="input-group-name"
          label="Apellidos:"
          label-for="input-lastname"
          class="mb-2"
          label-cols-md="2"
          content-cols-md="9"
          label-cols-lg="2"
          content-cols-lg="8"
      >
        <b-form-input
            id="lastname"
            v-model="form.lastname"
            class="mt-1"
            type="text"
            placeholder="Entra tus apellidos"
            required
        ></b-form-input>
      </b-form-group>

      <!-- phone -->
      <b-form-group
          id="input-group-phone"
          label="Teléfono:"
          label-for="input-phone"
          class="mb-2"
          label-cols-md="2"
          content-cols-md="9"
          label-cols-lg="2"
          content-cols-lg="8"
      >
        <b-form-input
            id="phone"
            v-model="form.phone"
            class="mt-1"
            type="tel"
            placeholder="(clave lada)-Número telefónico"
            required
        ></b-form-input>
      </b-form-group>

      <!-- email -->
      <b-form-group
          id="input-group-email"
          label="Correo:"
          label-for="input-email"
          class="mb-2"
          label-cols-md="2"
          content-cols-md="9"
          label-cols-lg="2"
          content-cols-lg="8"
      >
        <b-form-input
            id="email"
            v-model="form.email"
            class="mt-1"
            type="email"
            placeholder="Entra tu correo electrónico"
            required
        ></b-form-input>
      </b-form-group>

      <!-- institution -->
      <b-form-group
          id="input-group-institution"
          label="Institución:"
          label-for="input-institution"
          class="mb-2"
          label-cols-md="2"
          content-cols-md="9"
          label-cols-lg="2"
          content-cols-lg="8"
      >
        <b-form-input
            id="institution"
            v-model="form.institution"
            class="mt-1"
            type="text"
            placeholder="Entra el nombre de tu institución"
            required
        ></b-form-input>
      </b-form-group>

      <!-- comments -->
      <b-form-group
          id="input-group-comments"
          label="Comentarios:"
          label-for="input-comments"
          class="my-2"
          label-cols-md="2"
          content-cols-md="9"
          label-cols-lg="2"
          content-cols-lg="8"
      >
        <b-form-textarea
            id="comments"
            v-model="form.comments"
            placeholder="Entra los detalles de tu solicitud, dudas, sugerencias o comentarios."
            rows="5"
            max-rows="5"
            required
        ></b-form-textarea>
      </b-form-group>

      <!-- recaptcha -->
      <b-form-group
          id="input-group-recaptcha"
          label="Verificar:"
          label-for="recaptcha"
          class="mb-2"
          label-cols-md="2"
          content-cols-md="9"
          label-cols-lg="2"
          content-cols-lg="8"
      >
        <vue-recaptcha
          :sitekey="siteKey"
          :load-recaptcha-script="true"
          @verify="onVerify"
          @expired="robot = true"
        />
      </b-form-group>

      <!--  buttons -->
      <div class="mx-auto mt-5" style="width: 305px">
        <b-button
          class="mx-2"
          size="lg"
          variant="primary"
          type="submit"
          :disabled="robot || submitting"
        >
          <span>{{ !submitting ? 'Enviar' : 'Enviando...' }}</span>
        </b-button>
        <b-button class="mx-2 btn-lg btn-primary" type="reset">
          <span>Limpiar</span>
        </b-button>
      </div>
    </b-form>
  </b-overlay>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha';
  import { contentMethods } from '@state/helpers'

  export default {
    name: "Contact",

    components: {
      'vue-recaptcha': VueRecaptcha
    },

    data() {
      return {
        form: {
          name: '',
          lastname: '',
          phone: '',
          email: '',
          institution: '',
          comments: '',
        },
        siteKey: process.env.VUE_APP_RECAPTCHA,
        robot: true,
        submitting: false
      }
    },

    methods: {
      ...contentMethods,

      onSubmit(event) {
        event.preventDefault()
        this.submitting = true;
        this.submit(this.form)
            .then((response) => {
              if (response.status === 'success') {
                this.onReset(event);
                this.showToast('La información de contacto fue enviada correctamnete. Muchas Gracias.', true);
              } else {
                this.showToast(response.message, false);
              }
              this.submitting = false;
            })
            .catch((_) => {
              this.showToast('Lo sentimos, la información de contacto no pudo ser enviada.', false);
              this.submitting = false;
            })
      },

      onReset(event) {
        event.preventDefault()
        this.form.name = ''
        this.form.lastname = ''
        this.form.phone = ''
        this.form.email = ''
        this.form.institution = ''
        this.form.comments = ''
        // Trick to reset/clear native browser form validation state
        this.show = false
        this.$nextTick(() => {
          this.show = true
        })
      },

      onVerify(response) {
        console.log(response);
        this.robot = !response;
      },

      showToast(message, success) {
        this.$toast.open({
          message: message,
          type: success ? 'success' : 'error',
          duration: 5000,
          dismissible: true
        })
      }
    }
  }
</script>

<style lang="scss">
  @import '@design';

  @media only screen and (min-width: 768px) {
    .responsive-form .form-row {
      display: flex;
      flex-wrap: wrap;
      margin: 25px -5px !important;
    }

    .responsive-form label {
      padding-right: 10px;
      margin-top: 10px;
      text-align: right !important;
    }
  }

  .responsive-form label {
    font-weight: bold;
  }

  .responsive-form input {
    height: 50px;
  }

  .responsive-form button span{
    display: inline-block;
    min-width: 100px;
  }

  .responsive-form .btn-primary {
    background-color: $color-container-bg;
    border-color: $color-container-bg;
  }

  .v-toast__item {
    max-width: 450px;
  }

</style>
